import * as swcHelpers from '@swc/helpers';

const sortAddresses = (list)=>list.map((address)=>swcHelpers.objectSpread({}, address, {
            createdAt: address.createdAt || '0'
        })
    ).sort((a, b)=>b.createdAt.localeCompare(a.createdAt, 'en', {
            usage: 'sort',
            numeric: true
        })
    ).sort((a, b)=>b.addressTypes.length - a.addressTypes.length
    )
;

export { sortAddresses };
//# sourceMappingURL=sort-addresses.js.map
